import { Controller } from "@hotwired/stimulus"
import { formatBRL } from "../utils/format"

// Looks up a scanned/typed card code, shows its balance, writes it into the sale
// form's hidden field, and dispatches card:loaded so the POS cart unlocks.
export default class extends Controller {
  static values  = { url: String }
  static targets = ["code", "hidden", "balance", "status"]

  async load() {
    const code = this.codeTarget.value.trim()
    if (!code) return

    this.#status("Consultando…")
    let response
    try {
      response = await fetch(`${this.urlValue}?code=${encodeURIComponent(code)}`, { headers: { Accept: "application/json" } })
    } catch {
      this.#status("Sem conexão. Tente novamente.")
      return
    }

    if (!response.ok) {
      this.#status("Cartão não encontrado.")
      return
    }

    const data = await response.json()
    if (this.hasHiddenTarget)  this.hiddenTarget.value = code
    if (this.hasBalanceTarget) this.balanceTarget.textContent = formatBRL(data.balance)
    this.#status("")
    this.dispatch("loaded", { prefix: "card", detail: { id: data.id, balance: data.balance, code } })
  }

  // Fills the code from a QR scan (qr:read) and looks it up immediately.
  scanned(event) {
    this.codeTarget.value = event.detail.code
    this.load()
  }

  #status(text) {
    if (this.hasStatusTarget) this.statusTarget.textContent = text
  }
}
